import React, { useContext } from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { Field } from 'formik';
import { FormServiceContext } from 'app/utils/contexts';
import withLicenseDuplicateVehicle from 'app/components/Hoc/withLicenseDuplicateVehicle';

function Vehicle(props) {
  const {
    errors,
    classes,
    oldVehicle,
    newVehicle,
    handleChangeNewVehicle,
    inspectedVehiclesFiltered,
    vehicleIndex,
  } = props;
  const { canEdit, isInternalForm } = useContext(FormServiceContext);

  return (
    <>
      {Object.keys(oldVehicle).length > 0 && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.greenTitle}>Selecione o veículo novo</h3>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl
              variant="filled"
              margin="dense"
              disabled={isInternalForm || !canEdit}
              fullWidth
              error={
                errors.licencaVeiculos &&
                !!errors.licencaVeiculos[vehicleIndex]?.cdVeiculoSubstituir
              }
              onChange={e => handleChangeNewVehicle(e.target.value, vehicleIndex)}
            >
              <InputLabel
                shrink={true}
                htmlFor={`licencaVeiculos[${vehicleIndex}].cdVeiculoSubstituir`}
              >
                Placa novo veículo
              </InputLabel>
              <Field
                name={`licencaVeiculos[${vehicleIndex}].cdVeiculoSubstituir`}
                id={`licencaVeiculos[${vehicleIndex}].cdVeiculoSubstituir`}
                native
                as={Select}
                validate={value => {
                  let error;
                  if (!value) {
                    error = 'Campo obrigatório';
                  }
                  return error;
                }}
              >
                <option aria-label="None" value="" />
                {inspectedVehiclesFiltered.map((v, index) => {
                  return (
                    <option key={`cdVeiculo-${index}`} value={v.cdVeiculo}>
                      {v.dePlaca}
                    </option>
                  );
                })}
              </Field>
              {errors.licencaVeiculos &&
              errors.licencaVeiculos[vehicleIndex]?.cdVeiculoSubstituir ? (
                <FormHelperText>
                  {errors.licencaVeiculos[vehicleIndex]?.cdVeiculoSubstituir}
                </FormHelperText>
              ) : null}
            </FormControl>
          </Grid>
          {Object.keys(newVehicle).length > 0 && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  name=""
                  label="Município"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.city}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name=""
                  label="Nome / Razão Social"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.name}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name=""
                  label="CNPJ / CPF"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.document}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name=""
                  label="Tipo de veículo"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.type}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  name=""
                  label="Capacidade"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.capacity}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  name=""
                  label="Categoria"
                  margin="dense"
                  variant="filled"
                  fullWidth
                  disabled
                  value={newVehicle.category}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
}

export default withLicenseDuplicateVehicle(Vehicle);
